import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pms`;
const AuthContext = createContext(null);

axios.interceptors.request.use((config) => {
  const t = localStorage.getItem("pms_token");
  if (t && config.url?.includes("/api/pms")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("pms_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem("pms_token"); setUser(null); };

  useEffect(() => {
    const t = localStorage.getItem("pms_token");
    if (!t) { setLoading(false); return; }
    axios.get(`${API}/auth/me`)
      .then(({ data }) => setUser(data))
      .catch(() => { localStorage.removeItem("pms_token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const API_URL = API;
